import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { 
  collection, 
  getDocs, 
  doc, 
  getDoc,
  addDoc, 
  updateDoc, 
  deleteDoc,
  query,
  where,
  orderBy,
  onSnapshot
} from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyB1qKWj1R_Dp8ptmSo9hY6lownY5sTKg_g",
  authDomain: "stemtree-pickup-app.firebaseapp.com",
  projectId: "stemtree-pickup-app",
  storageBucket: "stemtree-pickup-app.firebasestorage.app",
  messagingSenderId: "759207344549",
  appId: "1:759207344549:web:2428b80c0bfee60eb5904c",
  measurementId: "G-CCBGJ23PLX"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);

// Export all Firestore functions
export {
  collection,
  getDocs,
  doc,
  getDoc,
  addDoc,
  updateDoc,
  deleteDoc,
  query,
  where,
  orderBy,
  onSnapshot
};